import { render, staticRenderFns } from "./FreightTableDetailsView.vue?vue&type=template&id=c809d9a4&scoped=true"
import script from "./FreightTableDetailsView.vue?vue&type=script&lang=js"
export * from "./FreightTableDetailsView.vue?vue&type=script&lang=js"
import style0 from "./FreightTableDetailsView.vue?vue&type=style&index=0&id=c809d9a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c809d9a4",
  null
  
)

export default component.exports